module.exports = __webpack_public_path__ + "static/carousel-hero-android-2x-736ca26ea5f55120450e0e65226eb91a.png";